var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.terminal === '1')?_c('terminal-pesagem'):_vm._e(),(_vm.terminal === '2')?_c('auto-terminal'):_vm._e(),(_vm.terminal === '3')?_c('kds-gestor'):_vm._e(),(_vm.terminal === '4')?_c('monitor'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }